function tourCtrl ($scope) {

}

const tourCtrlModule = angular.module('tourCtrl', [])
  .controller('tourCtrl', ['$scope', tourCtrl])
  .name;

export default tourCtrlModule;
